"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelAndHelpText = void 0;
var react_1 = __importDefault(require("react"));
var Label_1 = require("../Label");
var LabelAndHelpText_styles_1 = require("./LabelAndHelpText.styles");
/**
 * A container for the label and help text.
 */
var LabelAndHelpText = function (_a) {
    var id = _a.id, label = _a.label, helpText = _a.helpText, _b = _a.size, size = _b === void 0 ? 'small' : _b;
    return (react_1.default.createElement(LabelAndHelpText_styles_1.TextContainer, null,
        react_1.default.createElement(Label_1.Label, { htmlFor: id, labelText: label, size: size }),
        helpText && react_1.default.createElement(LabelAndHelpText_styles_1.HelpText, { "$size": size }, helpText)));
};
exports.LabelAndHelpText = LabelAndHelpText;
